import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles((theme) => ({
  online: {
    fontSize: 11,
    color: "#25d366",
  },
  offline: {
    fontSize: 11,
    color: "#e1306c",
  },
  searchIcon: {
    color: theme.palette.neutral300,
  },
  searchInput: {
    fontSize: "16px",
    lineHeight: "20px",
    fontWeight: "400",
    letterSpacing: "-0.25%",
    color: theme.palette.neutral300,
  },
  barraDePesquisa: {
    paddingTop: "10px",
    paddingBottom: "10px",
    paddingLeft: theme.espacamento.spacing400,
    paddingRight: theme.espacamento.spacing400,
    margin: "16px",

    height: "52px",
    backgroundColor: theme.palette.background200,
    borderRadius: theme.radius.radius300,
  },
  chipLabel: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    whiteSpace: "nowrap",
  },
  chipSelecionado: {
    backgroundColor: theme.palette.background300,
    color: theme.palette.primary200,
    border: `1px solid ${theme.palette.primary100}`,
    "&:hover": {
      backgroundColor: theme.palette.background300,
      color: theme.palette.primary200,
    },
    "&:focus": {
      backgroundColor: theme.palette.background300,
      color: theme.palette.primary200,
    },
  },
  chipDefault: {
    backgroundColor: theme.palette.background200,
    color: theme.palette.neutral300,
    "&:hover": {
      backgroundColor: theme.palette.background200,
      color: theme.palette.neutral300,
    },
    "&:focus": {
      backgroundColor: theme.palette.background200,
      color: theme.palette.neutral300,
    },
  },
  chipContainer: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    gap: theme.espacamento.spacing200,
    overflowX: "auto",
    paddingLeft: theme.espacamento.spacing400,
    paddingRight: theme.espacamento.spacing400,
    marginBottom: "16px",

    // comportamento do scroll
    scrollBehavior: "smooth",

    // estilização do scroll (webkit)
    "&::-webkit-scrollbar": {
      height: 6, // controla a espessura horizontal
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent", // remove fundo
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "rgba(0,0,0,0.2)", // cor discreta
      borderRadius: 8,
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "rgba(0,0,0,0.35)",
    },

    // para Firefox
    scrollbarWidth: "thin",
    scrollbarColor: "rgba(0,0,0,0.2) transparent",
  },

  btnFullWidth: {
    width: "100%",
    minHeight: "40px",
    borderRadius: "12px",
    fontWeight: 500,
  },
  buttonsContainer: {
    backgroundColor: theme.palette.background100,
    minHeight: "72px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    gap: "8px",
    paddingTop: "16px",
    paddingBottom: "16px",
    paddingLeft: "24px",
    paddingRight: "24px",
  },
  button: {
    letterSpacing: "-0.25%",
    lineHeight: "24px",
    fontFamily: "Roboto",
    fontSize: "16px",
    textTransform: "none",
    minWidth: "100%",
    height: "56px",
    borderRadius: "12px",

    "@media (max-width: 768px)": {
      width: "100%",
    },
  },
  buttonBox: {
    paddingBottom: "16px",
    paddingTop: "16px",
    display: "flex",
    alignItems: "center",

    "@media (max-width: 768px)": {
      paddingLeft: "0px",
      paddingRight: "0px",
      marginLeft: "0px",
    },
  },
  slideIn: {
    animation: `$slideIn 0.5s forwards`,
  },
  slideOut: {
    animation: `$slideOut 0.5s forwards`,
  },
  "@keyframes slideIn": {
    from: { transform: "translateX(100%)", opacity: 0 },
    to: { transform: "translateX(0)", opacity: 1 },
  },
  "@keyframes slideOut": {
    from: { transform: "translateX(0)", opacity: 1 },
    to: { transform: "translateX(100%)", opacity: 0 },
  },
  tituloNovaConversa: {
    height: "73px",
    padding: "24px",
    display: "flex",
    Justify: "space-between",
    alignItems: "center",
    fontFamily: "Roboto",
    fontSize: "20px",
    lineHeight: "25px",
    letterSpacing: "-0.25px",
    color: theme.palette.neutral400,
    backgroundColor: theme.palette.backgroundl100,
  },
  boxNovaConversa: {
    position: "absolute",
    right: 0,
    top: 0, // Ajuste conforme necessário
    margin: 0,
    minHeight: 816,
    width: 400,
    borderRadius: "12px",

    "@media (max-width: 768px)": {
      minWidth: "100%",
      maxWidth: "100%",
      minHeight: "100%",
      borderRadius: "0px",
    },
  },
  iconButton: {
    marginLeft: "auto", // Empurra o botão para o final
    padding: "0px",
  },
  iconX: {
    color: theme.palette.neutral400,
  },
  iconChevronDown: {
    color: theme.palette.neutral300,
  },
  content: {
    backgroundColor: theme.palette.background200,
    paddingLeft: "32px",
    paddingRight: "32px",

    "@media (max-width: 768px)": {
      paddingLeft: "7%",
      paddingRight: "7%",
    },
  },
  autocomplete: {
    backgroundColor: theme.palette.background100,
    borderRadius: "12px",
    marginBottom: "10px",
    marginTop: "10px",

    "& .MuiOutlinedInput-root": {
      borderRadius: "12px", // Aplica o borderRadius corretamente
      "& fieldset": {
        borderColor: theme.palette.neutral300, // Cor da borda
      },
    },
  },
  textField: {
    color: theme.palette.neutral400,
    border: theme.palette.neutral300,
  },
  label: {
    color: theme.palette.neutral400,

    "& .MuiFormLabel-asterisk": {
      display: "none", // Esconde o asterisco
    },
  },
}))

export default useStyles
